import * as React from 'react';

var _rect, _path, _path2, _path3, _path4, _g, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgAppIconinline = function SvgAppIconinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 48,
    height: 48,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#C4C4C4",
    rx: 14.006
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4036ED",
    d: "M-129.455-73.603h347.2V86.441h-347.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFB8BE",
    strokeWidth: 37.349,
    d: "M-53.668 16.772C-20.88 30.086 6.98 21.388 38.135-18.11c26.906-34.116 48.74-42.962 79.553-30.276"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF6668",
    strokeWidth: 37.349,
    d: "M-59.231 12.865c25.11 24.936 54.17 27.663 98.152 3.247 37.988-21.09 61.545-20.824 85.075 2.77"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 198,
    height: 122,
    x: -66,
    y: -74,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFB8BE",
    strokeWidth: 37.349,
    d: "M-52.933 18.442c32.79 13.314 60.65 4.616 91.803-34.882 26.906-34.116 48.74-42.962 79.553-30.276"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FF9395",
    strokeWidth: 37.349,
    d: "M-58.496 12.867c25.111 24.936 54.17 27.663 98.153 3.247C77.644-4.976 101.2-4.71 124.73 18.884"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.473 27.035c0 2.024 1.102 3.245 2.92 3.245.578 0 1.156-.111 1.79-.333v.194c-1.047 1.636-2.534 2.552-4.407 2.552-2.451 0-4.241-1.554-4.241-4.494v-7.766H8.166v-.305l5.977-5.463h.33v12.37Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m25.393 32.61 2.011-4.466-4.159-9.569h-7.808v1.858h4.31l5.371 12.176h.275Zm1.267-14.035h4.297l4.159 9.569-2.01 4.465h-.276l-6.17-14.034Zm9.86 5.353c0-1.331-.605-3.994-1.294-5.353h4.187l-2.7 5.353h-.193Z"
  })));
};
var AppIcon = SvgAppIconinline;

export { AppIcon as default };
//# sourceMappingURL=app-icon.inline.svg.js.map
